import { Box, Typography } from '@mui/material';

interface TaskCapsuleProps {
  capsuleHeight?: number;
  title: string;
  imgSrc: string;
  imgAlt?: string;
  imgWidth?: string;
  subTitle?: string;
  handleClick?: () => void;
}

const TaskCapsule = ({
  capsuleHeight,
  title,
  imgSrc,
  imgAlt,
  imgWidth,
  subTitle,
  handleClick,
}: TaskCapsuleProps) => {
  return (
    <Box
      sx={{
        height: capsuleHeight,
        bgcolor: 'ghostWhite.main',
        gap: 4,
        pl: 3.25,
        pr: 2,
      }}
      className="d-flex align-items-center rounded-50 cursor-pointer"
      onClick={handleClick}
    >
      <Box className="flex-1">
        <Typography
          variant="h6"
          sx={{ color: 'text.primary' }}
          className="flex-1"
          mb={1.5}
        >
          {title}
        </Typography>
        {subTitle && (
          <Typography variant="body1" color="text.secondary">
            {subTitle}
          </Typography>
        )}
      </Box>
      {imgSrc && <img src={imgSrc} alt={imgAlt} width={imgWidth} />}
    </Box>
  );
};

export default TaskCapsule;
